angular.module('gym.calendar').factory('KioskService', ["$rootScope", "$state", "$http", "$window", "FeatureAvailabilityService", "flash", "CwStorage", function($rootScope, $state, $http, $window, FeatureAvailabilityService, flash, CwStorage) {
  return {
    enterKioskMode: function() {
      var url;
      if (FeatureAvailabilityService.isAvailable('attendance')) {
        url = `gyms/${$rootScope.gym.id}/kiosk/enter`;
        $window.open(url, '_self');
        return true;
      } else {
        return FeatureAvailabilityService.showNotAvailableMessage('General Kiosk');
      }
    },
    enterClassKioskMode: function(params = {}) {
      var eventParams, serializedParams, url;
      if (FeatureAvailabilityService.isAvailable('attendance')) {
        CwStorage.removeItem('class_auto_cycle_enabled');
        eventParams = _.pick(params, function(val) {
          return val;
        });
        serializedParams = angular.element.param(eventParams);
        url = `gyms/${$rootScope.gym.id}/event_kiosk/enter?${serializedParams}`;
        $window.open(url, '_self');
        return true;
      } else {
        return FeatureAvailabilityService.showNotAvailableMessage('Class Kiosk');
      }
    },
    enterRollCall: function() {
      var nextEventUrl;
      if (FeatureAvailabilityService.isAvailable('attendance')) {
        nextEventUrl = `/gyms/${$rootScope.gym.id}/roll_call/todays_next_event`;
        return $http.get(nextEventUrl).then(function(response) {
          var eventId, url;
          eventId = response.data.event.id;
          url = `gyms/${$rootScope.gym.id}/roll_call/${eventId}`;
          $window.open(url, '_self');
          return true;
        }, function() {
          $state.go($rootScope.defaultCalendarView);
          return flash.error = 'No events found.';
        });
      } else {
        return FeatureAvailabilityService.showNotAvailableMessage('Roll Call');
      }
    }
  };
}]);
